import { render, staticRenderFns } from "./CampaignSpef.vue?vue&type=template&id=6c58c35a&"
import script from "./CampaignSpef.vue?vue&type=script&lang=js&"
export * from "./CampaignSpef.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSpef.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports